import React, { useContext } from 'react';
import SubTitle from '../../../SubTitle';
import styles from './index.module.scss';
import GasTypeCards from './GasTypeCards';
import GasCostPie from './GasCostPie';
import AlarmStats from './AlarmStats';
import titleIcon from '@/assets/images/title_icon.png';
import { Dropdown } from '@maxtropy/components';
import SwitchDate, { IndexTimeActive } from './SwitchDate';
import dayjs from 'dayjs';
import { GasMonitorContext } from '../../context';

const LeftBox: React.FC = () => {
  const { timeResolution, dateValue, setActiveKey, setValue } = useContext(GasMonitorContext);

  return (
    <>
      <SubTitle
        title="用量成本统计"
        img={titleIcon}
        style={{ flex: '1 1 466px', height: 0, paddingTop: 0 }}
        extraContent={
          <Dropdown
            type="link"
            className={styles.dropdown_wrapper}
            getPopupContainer={() => document.getElementById('full_screen_box') ?? document.body}
            trigger={['click']}
            dropdownRender={() => (
              <div className={styles.dropdown_menu_wrapper}>
                <SwitchDate
                  activeKey={timeResolution}
                  value={dateValue}
                  setActiveKey={setActiveKey}
                  setValue={setValue}
                />
              </div>
            )}
          >
            {dayjs(dateValue).format(timeResolution === IndexTimeActive.THIS_MONTH ? 'YYYY-MM' : 'YYYY')}
          </Dropdown>
        }
      >
        <GasTypeCards />
      </SubTitle>
      <SubTitle title="气体成本" img={titleIcon} style={{ flex: '1 1 234px', height: 0 }}>
        <GasCostPie />
      </SubTitle>
      <SubTitle title="近七日未恢复告警" img={titleIcon} style={{ flex: '1 1 234px', height: 0 }}>
        <AlarmStats />
      </SubTitle>
    </>
  );
};

export default LeftBox;
